import request from '@/utils/request'

// 获取学院建设统计情况
export function getCollegeConstructStats(data) {
  let { responseType, ...restData } = data
  return request({
    url: 'stats/supervision/college',
    method: 'POST',
    data: restData,
    responseType: responseType || '',
  })
}
// 获取课程建设统计情况
export function getCourseConstructStats(data) {
  let { responseType, ...restData } = data
  return request({
    url: 'stats/supervision/course',
    method: 'POST',
    data: restData,
    responseType: responseType || '',
  })
}
// 获取课程教师行为统计
export function getCourseTeacherStats(data) {
  let { responseType, ...restData } = data
  return request({
    url: 'stats/supervision/teacher',
    method: 'POST',
    data: restData,
    responseType: responseType || '',
  })
}
// 获取课程学生行为统计
export function getCourseStudentStats(data) {
  let { responseType, ...restData } = data
  return request({
    url: 'stats/supervision/student',
    method: 'POST',
    data: restData,
    responseType: responseType || '',
  })
}
